/** When true, subscription gates and upgrade prompts are active for MSME users. */
export const SUBSCRIPTION_PLANS_ENABLED = false;

export const PLAN_UPGRADE_CONTACT_EMAIL = 'contact@sustainow.in';
